import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import DesktopMobileChat from "ui/chat/classic/mobile/MobileChat";
import Column from "../components/Column";

class MobileChat extends React.Component {

	render() {
		return(
			<Column
				id="browser"
				title={ [this.props.configuration.interface.chat.title, this.props.titleOverride].filter( title => title && title.length ).join(' - ') }
				contentClassName="wcMobileContainer"
				unreadNumber={ this.props.recentChats.filter( recentChat => recentChat.read === false).length + this.props.userFeed.filter( userFeedEntry => userFeedEntry.seen === false).length }
			>
				<DesktopMobileChat visible={true} titleVisible={ false } />
			</Column>

		)
	}

}

MobileChat.propTypes = {
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		titleOverride: state.ui.mobile.title,
		recentChats: state.application.recentChats,
		userFeed: state.application.userFeed
	})
)(MobileChat);